import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from 'sd-ui/dist/commonjs/components/Button/Button';
import Icon from '../../icon';

export default function CloseButton({
  className, onClick, children, id,
}) {
  return (
    <Button
      id={id}
      className={classnames(className, 'button-anchor')}
      icon={Icon.Cross}
      iconPlacement="right"
      onClick={onClick}
    >
      {children}
    </Button>
  );
}

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node,
  id: PropTypes.string,
  className: PropTypes.string,
};

CloseButton.defaultProps = {
  children: undefined,
  id: undefined,
  className: undefined,
};
